import { render, staticRenderFns } from "./index.vue?vue&type=template&id=292ed9f8"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data0/web/xyadmin.98du.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('292ed9f8')) {
      api.createRecord('292ed9f8', component.options)
    } else {
      api.reload('292ed9f8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=292ed9f8", function () {
      api.rerender('292ed9f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/nested/menu2/index.vue"
export default component.exports